module.exports = __webpack_public_path__ + "static/media/Cam-01.3354117e.webp";